import { _elements } from './_elements';
import { _scroll } from './_scroll';

/*
 * This function navigates to the previous-item.
 */
export const _prev = ( { target } ) => {
	const {
		slider,
		current,
		items,
	} = _elements( target.closest( '[data-slider]' ) );

	const prev = items[ current - 1 ];

	if ( prev ) {
		_scroll( slider, prev );
	}
};
